module.exports = __webpack_public_path__ + "img/logo.c58c0c26.png";